var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashboardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 11V3.5H11.5V11H4ZM4 20.5V13H11.5V20.5H4ZM13.5 11V3.5H21V11H13.5ZM13.5 20.5V13H21V20.5H13.5ZM5.49997 9.5H10V4.99998H5.49997V9.5ZM15 9.5H19.5V4.99998H15V9.5ZM15 19H19.5V14.5H15V19ZM5.49997 19H10V14.5H5.49997V19Z",
    fill: "#2E3336"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardIcon);
export default __webpack_public_path__ + "static/media/dashboardIcon.27c21001be46404c3cd447cb859cabea.svg";
export { ForwardRef as ReactComponent };